export const RECONNECT_MIN_MS = 1000
export const RECONNECT_MAX_MS = 30_000

/**
 * Backoff for the notifications stream, with full jitter.
 *
 * Without jitter every client of a restarted gateway replica retries on the
 * same schedule, so the replica comes back to a synchronised wave of
 * reconnects — and each wave reforms on the next failure. Spreading each
 * client over [half, full] of its own backoff breaks the lockstep.
 */
export function nextReconnectDelay(
  previous: number,
  random: () => number = Math.random
): number {
  const base = Math.min(
    Math.max(previous, RECONNECT_MIN_MS) * 2,
    RECONNECT_MAX_MS
  )

  return Math.round(base * (0.5 + random() * 0.5))
}

/** The wait before the first retry, jittered the same way. */
export function firstReconnectDelay(
  random: () => number = Math.random
): number {
  return Math.round(RECONNECT_MIN_MS * (0.5 + random() * 0.5))
}
